<template>
  <div>
    <template v-if="isMobileDevice">
      <div v-if="items.length">
        <CustomersCard
          v-for="item of items"
          :id="item.id"
          :key="item.id"
          :name="item.name"
          :customers="item.customers"
          :status="{ text: item.isActive, color: item.isActive ? 'green' : 'red' }"
          @clickOnOrder="onClickRow({ id: item.id })"
        />
      </div>
      <div v-else>{{ $t("page.dashboard.emptyMessage") }}</div>
    </template>

    <OurTable
      v-else
      :headers="tableHeaders"
      :items="items"
      :table-fixed="false"
      @clickRow="onClickRow"
    >
    </OurTable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomersCard from "@/components/MobileCards/CustomersCard.vue";

export default {
  name: "FocusGroupList",
  components: { CustomersCard },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),

    tableHeaders() {
      const data = [
        {
          value: "id",
          text: this.$t("focusGroup.id"),
          thClass: "w-24",
          tdClass: "max-w-[2rem] min-w-[5rem]",
        },
        {
          value: "name",
          text: this.$t("focusGroup.name"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[9rem] min-w-[7rem]",
        },
        {
          value: "customers",
          text: this.$t("focusGroup.customers"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[9rem] min-w-[7rem]",
        },
        {
          value: "isActive",
          text: this.$t("focusGroup.isActive._"),
          thClass: "w-[5rem]",
          tdClass: "max-w-[9rem] min-w-[7rem]",
        },
      ];

      return data;
    },
  },

  methods: {
    onClickRow(row) {
      this.$emit("onClickRow", row.id);
    },
  },
};
</script>
